import API from '@/api/api-main';

// Mã PTTT dùng rải rác ở nhiều màn hình — gom về một chỗ để không viết chuỗi rời rạc.
export const PAYMENT_METHOD = {
    CASH: 'Cash',
    BANK_WIRE: 'BankWire',
    BANK_CARD: 'BankCard',
    VOUCHER: 'Voucher'
};

// PTTT có gắn tài khoản ngân hàng (chọn STK, sinh QR động). Voucher thu tại quầy
// như tiền mặt nên KHÔNG thuộc nhóm này.
export const BANK_PAYMENT_CODES = [PAYMENT_METHOD.BANK_WIRE, PAYMENT_METHOD.BANK_CARD];

// isActive của danh mục PaymentMethod là chuỗi tự do, mỗi môi trường một kiểu
// ('Y', 'true', '1'…) vì các dòng được thêm bằng script và backend KHÔNG lọc giúp.
// Vì vậy chỉ loại những giá trị "tắt" rõ ràng, còn lại coi là đang bật — thà hiện
// thừa một phương thức còn hơn nuốt mất phương thức mới thêm.
const INACTIVE_FLAGS = ['n', 'no', 'false', '0', 'inactive'];

export const isPaymentMethodActive = (paymentMethod) => {
    const flag = paymentMethod?.isActive;
    if (flag === null || flag === undefined || flag === '') return true;
    return !INACTIVE_FLAGS.includes(String(flag).trim().toLowerCase());
};

// Voucher chỉ dùng chiều THU. Backend trả 400 cho phiếu chi, nhưng không để thu ngân
// chọn xong mới báo lỗi — ẩn luôn khỏi dropdown ở các luồng chi tiền cho khách.
export const isIncomingOnlyMethod = (code) => code === PAYMENT_METHOD.VOUCHER;

// Chứng từ có sẵn ô "Voucher" là voucher CŨ — tiền giảm giá (distcountAmountVoucher).
// Voucher mới là một PTTT: khách trả tiền bằng voucher. Hai thứ khác hẳn nhau nên chỗ
// nào hiện tiền voucher trả hàng đều phải dùng nhãn này để thu ngân không đọc nhầm.
export const VOUCHER_PAYMENT_LABEL = 'Voucher (Thanh toán)';

// Tổng tiền khách trả bằng một PTTT trên chứng từ. Luôn CỘNG mọi dòng cùng mã chứ không
// lấy dòng đầu bằng find(): đơn đặt hàng giữ cả dòng của khoản cọc (dpmInvoice) lẫn dòng
// trả nốt, hai dòng này hoàn toàn có thể cùng một PTTT (cọc quẹt thẻ, trả nốt cũng thẻ).
// Nhận cả mảng paymentMethod (hoá đơn/đơn hàng) lẫn paymentLine (phiếu thu, kết ca)
// vì hai nơi đặt tên khác nhau nhưng cùng cấu trúc { paymentMethodCode, amount }.
export const sumPaymentByCode = (paymentLines, code) =>
    (paymentLines || []).filter((line) => line?.paymentMethodCode?.toLowerCase() === String(code || '').toLowerCase()).reduce((total, line) => total + (Number(line?.amount) || 0), 0);

// Tổng tiền khách trả bằng PTTT Voucher trên một chứng từ.
export const getVoucherPaymentAmount = (paymentLines) => sumPaymentByCode(paymentLines, PAYMENT_METHOD.VOUCHER);

// Toàn bộ danh mục PTTT, kể cả dòng đã tắt.
// - Không truyền Filter=(isActive=…) lên server vì giá trị isActive không đồng nhất
//   giữa các môi trường và backend không lọc theo nó.
// - Luôn xin pageSize lớn: id của từng dòng do DB sinh nên phải đọc đủ danh mục,
//   thiếu dòng nào là dòng thanh toán đó gửi lên paymentMethodId = 0.
export const getPaymentMethodCatalog = async () => {
    try {
        const { data } = await API.get('PaymentMethod?page=1&pageSize=200');
        return data?.items || [];
    } catch (error) {
        return [];
    }
};

// Danh mục PTTT đang bật — dùng cho dropdown cho thu ngân chọn.
export const getActivePaymentMethods = async () => (await getPaymentMethodCatalog()).filter(isPaymentMethodActive);
